var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightEnabled = function SvgChevronRightEnabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 13 6-6-6-6",
    stroke: "#248BF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgChevronRightEnabled as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M1 13L7 7L1 1' stroke='%23248BF2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";